import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AlogEvent,
  FormEditor,
  FormPanel,
  auditLogFactory,
  useFormSelector,
} from '@eas/common-web';

export function Fields() {
  const { detail } = useFormSelector((data: AlogEvent) => ({
    detail: data.detail,
  }));

  const Fields = auditLogFactory.Fields;

  return (
    <>
      <Fields />
      {detail && (
        <FormPanel
          label={
            <FormattedMessage
              id="ES__ALOG___DETAIL__DETAIL_PANEL_TITLE"
              defaultMessage="Detail"
            />
          }
        >
          <FormEditor
            name="detail"
            labelOptions={{ hide: true }}
            language="json"
          />
        </FormPanel>
      )}
    </>
  );
}
